<div class="flexiblePageComp container-fluid">
  <div class="flexiblePage container comp">
    <div class="flexiblePageLeft">
      <p class="p5">Flexible Payment Options</p>
      <p class="p2">
        Enjoy the flexibility to choose your preffered payment method from our
        unique offering.
      </p>
      <a class="ctaButton5 web" target="_blank" href="https://pay.klickit.co/">Pay Now
        <span><img src="../../../assets/images/chevron.right2.svg" /></span>
      </a>
    </div>

    <div class="flexiblePageRight">
      <div class="flexiblePageRightInner">
      <div class="flexibleCard">
        <img src="../../../assets/images/mobPayment.gif" />
        <div class="flexibleCardText">
          <p class="p5">Online</p>
          <p class="flexibleCardText2">
            Pay using Credit/Debit cards from the convenience of your home.
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/POS.gif" />
        <div class="flexibleCardText">
          <p class="p5">POS</p>
          <p class="flexibleCardText2">
            Easily pay using your card on the school premises.
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/ATM.gif" />
        <div class="flexibleCardText">
          <p class="p5">ATMs</p>
          <p class="flexibleCardText2">
            Using a cardless transaction, in few steps, pay at the nearest ATM.
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/wallets.gif" />
        <div class="flexibleCardText">
          <p class="p5">Wallets</p>
          <p class="flexibleCardText2">
            Easily pay using your telecom, mobile, or bank wallets such as
            Vodafone Cash.
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/payNet.gif" />
        <div class="flexibleCardText">
          <p class="p5">Payment Networks</p>
          <p class="flexibleCardText2">
            Generate your reference number from Klickit, and head to the nearest
            store having one of our partners’ machines (Fawry, Aman, Masary,
            OPAY).
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/bankTransfer.gif" />
        <div class="flexibleCardText">
          <p class="p5">Bank Transfer</p>
          <p class="flexibleCardText2">
            No screenshots needed, no amount insertion, Klickit will be
            integrated and reflected for an easier payment.
          </p>
        </div>
      </div>

      <div class="flexibleCard">
        <img src="../../../assets/images/overCounter.gif" />
        <div class="flexibleCardText">
          <p class="p5">Over The Counter</p>
          <p class="flexibleCardText2">
            Visit the nearest branch of our partnering banks and deposit your
            payment.
          </p>
        </div>
      </div>
    </div>
    </div>

    <a class="ctaButton5 mob" target="_blank" href="https://pay.klickit.co/"
      >Pay Now
      <span><img src="../../../assets/images/chevron.right.white.svg" /></span>
    </a>
  </div>
</div>
